import React, { useEffect } from "react";
import { Card, Typography, Col, Row, Divider } from "antd";
import { useLocation } from "react-router-dom";

const { Title, Text } = Typography;

function AdminAppointmentDetails() {
  const location = useLocation();
  const appointment = location.state?.appointment; // Access passed data

  useEffect(() => {
    // Fetch appointment details if needed
  }, []);

  if (!appointment) return <Text>Loading...</Text>;

  // Extract booked slots
  const bookedSlots = appointment?.bookedBy || [];

  // Extract all available slots
  const allSlots = appointment?.slots || [];

  // Find available slots by filtering out booked slots
  const bookedSlotTimes = bookedSlots.map((b) => b.slot);
  const availableSlots = allSlots.filter((slot) => !bookedSlotTimes.includes(slot));

  return (
    <div
      style={{
        padding: "40px",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <Card
        title={<Title level={4}>Appointment Details</Title>}
        bordered={false}
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          borderRadius: "10px",
        }}
      >
        <Row gutter={[16, 16]} style={{ marginBottom: "20px" }}>
          <Col span={24}>
            <Title level={5} style={{ marginBottom: "10px", color: "#1890ff" }}>
              General Information
            </Title>
          </Col>
          <Col span={12}>
            <Text strong>Date:</Text>
            <br />
            <Text>{appointment?.date || "N/A"}</Text>
          </Col>
          <Col span={12}>
            <Text strong>Status:</Text>
            <br />
            <Text>{appointment?.status || "N/A"}</Text>
          </Col>
        </Row>

        <Divider />

        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Title level={5} style={{ marginBottom: "10px", color: "#1890ff" }}>
              Time Details
            </Title>
          </Col>
          <Col span={12}>
            <Text strong>Time From:</Text>
            <br />
            <Text>{appointment?.timeFrom || "N/A"}</Text>
          </Col>
          <Col span={12}>
            <Text strong>Time To:</Text>
            <br />
            <Text>{appointment?.timeTo || "N/A"}</Text>
          </Col>
        </Row>

        <Divider />

        {/* Available Slots Section */}
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Title level={5} style={{ marginBottom: "10px", color: "#52c41a" }}>
              Available Slots
            </Title>
          </Col>
          <Col span={24}>
            {availableSlots.length > 0 ? (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "10px",
                }}
              >
                {availableSlots.map((slot, index) => (
                  <div
                    key={index}
                    style={{
                      padding: "6px 12px",
                      backgroundColor: "#f0f2f5",
                      border: "1px solid #d9d9d9",
                      borderRadius: "8px",
                      fontSize: "14px",
                      color: "#595959",
                    }}
                  >
                    {slot}
                  </div>
                ))}
              </div>
            ) : (
              <Text>No available slots</Text>
            )}
          </Col>
        </Row>

        <Divider />

        {/* Booked Slots Section */}
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Title level={5} style={{ marginBottom: "10px", color: "#1890ff" }}>
              Booked Slots
            </Title>
          </Col>

          {bookedSlots.length > 0 ? (
            bookedSlots.map((booking, index) => (
              <Col span={24} key={index}>
                <Card
                  style={{
                    backgroundColor: "#f0f2f5",
                    padding: "10px",
                    borderRadius: "8px",
                    border: "1px solid #d9d9d9",
                  }}
                >
                  <Row gutter={[16, 16]}>
                    <Col span={12}>
                      <Text strong>Name:</Text>
                      <br />
                      <Text>{booking.name || "N/A"}</Text>
                    </Col>
                    <Col span={12}>
                      <Text strong>Email:</Text>
                      <br />
                      <Text>{booking.email || "N/A"}</Text>
                    </Col>
                    <Col span={12}>
                      <Text strong>Mobile No:</Text>
                      <br />
                      <Text>{booking.mobileNo || "N/A"}</Text>
                    </Col>
                    <Col span={12}>
                      <Text strong>Booked Slot Time:</Text>
                      <br />
                      <Text>{booking.slot || "N/A"}</Text>
                    </Col>
                  </Row>
                </Card>
              </Col>
            ))
          ) : (
            <Col span={24}>
              <Text>No booked slots</Text>
            </Col>
          )}
        </Row>
      </Card>
    </div>
  );
}

export default AdminAppointmentDetails;
